// Import all components
import Dashboard from "../Components/Dashboard";
import UnAuthorized from "../Components/UnAuthorized";
import Ano from "../Components/Masters/AnoMaster";
import Fno from "../Components/Masters/FnoMaster";
import SFA from "../Components/Masters/SfaMaster";
import UserMaster from "../Components/Masters/UserMaster";
import RoleMaster from "../Components/Masters/RoleMaster";
import InspectionAgencyMaster from "../Components/Masters/InspectionAgencyMaster";
import ProjectMaster from "../Components/Masters/ProjectMaster";
import DropdownValueMaster from "../Components/Masters/DropdownValueMaster";
import PCategory from "../Components/Masters/PCategoryMaster";
import Welder from "../Components/Masters/WelderMaster";
import WPSGroove_Overlay from "../Components/WPSTransaction/WPSGroove_Overlay";
import GrooveTransaction from "../Components/WPSTransaction/GrooveTransaction";
import WPSTubesheetTransaction from "../Components/WPSTransaction/WPSTubesheetTransaction";
import WPQGroove_Overlay from "../Components/WPQTransaction/WPQGroove_Overlay";
import WPQGrooveTransaction from "../Components/WPQTransaction/WPQGrooveTransaction";
import WPQTubeSheetTransaction from "../Components/WPQTransaction/WPQTubeSheetTransaction";
import TrainingMaster from "../Components/Training/Training Subject/TrainingMaster";
import TrainingRecord from "../Components/Training/Training Records/TrainingRecord";
import TrainingRequisition from "../Components/Training/Training Requisition/TrainingRequisitionMaster";
import Item from "../Components/Masters/ItemMaster";
import WeldingProcess from "../Components/Masters/WeldingProcessMaster";
import WCSDashboard from "../Components/WCSTransaction/WCSDashboard";
import WCSDetail from "../Components/WCSTransaction/WCSDetail";
import RaiseDeviationCapa from "../Components/Deviation/RaiseDeviationCapa";
import DeviationReport from "../Components/Deviation/DeviationReport";
import WIGridPage from "../Components/WITransaction/WIGridPage";
import List_Of_Welders from "../Components/ListOfWelders/List_Of_Welders";
import ProdLandPage from "../Components/PRODTransaction/ProdLandPage";
import ProdReport from "../Components/PRODTransaction/ProdReport";
import Welder_Record_sheet from "../Components/Welder Record Sheet/Welder_Record_sheet";
import WelderContinuityRecord from "../Components/Welder Continuity Record/WelderContinuityRecord";
import QualificationRequisition from "../Components/WQRTransaction/QualificationRequisitionMaster";
import WpqLinking from "../Components/WPQLinking/WpqLinking";
import WpqLinkingAddEdit from "../Components/WPQLinking/WpqLinkingAddEdit";
import WpqNpcilLinking from "../Components/WPQLinking/WpqNpcilLinking";
import WpqNpcilLinkingAddEdit from "../Components/WPQLinking/WpqNpcilLinkingAddEdit";
import WQChartReport from "../Components/WQChart/WelderQChart";
import PQRGroove_Overlay from "../Components/PQRTransaction/PQRGroove_Overlay";
import PQRGrooveTransaction from "../Components/PQRTransaction/PQRGrooveTransaction";
import PQRTubeSheetTransaction from "../Components/PQRTransaction/PQRTubeSheetTransaction";
import WeldingRepairAnalysis from "../Components/weldingRepair/WeldingRepairAnalysis";
import WeldingRepairAnalysisEntry from "../Components/weldingRepair/WeldingRepairAnalysisEntry";
import WeldingRepairAnalysisViewAll from "../Components/weldingRepair/WeldingRepairAnalysisViewAll";

// Environment constants
const TYPES = {
  GROOVE: process.env.REACT_APP_GROOVE_TYPE,
  OVERLAY: process.env.REACT_APP_OVERLAY_TYPE,
  TUBESHEET: process.env.REACT_APP_TUBESHEET_TYPE
};

// Route configuration
export const routeConfig = [
  // Public routes (no access control)
  {
    path: "/",
    component: Dashboard,
    requiresAuth: false
  },
  {
    path: "/unauthorized",
    component: UnAuthorized,
    requiresAuth: false
  },

  // WPS Routes
  {
    path: "/wps/Groove",
    component: WPSGroove_Overlay,
    access: "/wps/Groove",
    props: { type: TYPES.GROOVE },
    requiresRef: true
  },
  {
    path: "/wps/Groove/Groovetrans",
    component: GrooveTransaction,
    access: "/wps/Groove",
    props: { type: TYPES.GROOVE }
  },
  {
    path: "/wps/Overlay",
    component: WPSGroove_Overlay,
    access: "/wps/Overlay",
    props: { type: TYPES.OVERLAY },
    requiresRef: true
  },
  {
    path: "/wps/Overlay/Overlaytrans",
    component: GrooveTransaction,
    access: "/wps/Overlay",
    props: { type: TYPES.OVERLAY }
  },
  {
    path: "/wps/Tubesheet",
    component: WPSGroove_Overlay,
    access: "/wps/Tubesheet",
    props: { type: TYPES.TUBESHEET },
    requiresRef: true
  },
  {
    path: "/wps/Tubesheet/Tubesheettrans",
    component: WPSTubesheetTransaction,
    access: "/wps/Tubesheet"
  },

  // WPQ Routes
  {
    path: "/WPQTransaction/Groove",
    component: WPQGroove_Overlay,
    access: "/WPQTransaction/Groove",
    props: { type: TYPES.GROOVE },
    requiresRef: true
  },
  {
    path: "/wpq/Groove/Groovetrans",
    component: WPQGrooveTransaction,
    access: "/WPQTransaction/Groove",
    props: { type: TYPES.GROOVE }
  },
  {
    path: "/WPQTransaction/Overlay",
    component: WPQGroove_Overlay,
    access: "/WPQTransaction/Overlay",
    props: { type: TYPES.OVERLAY },
    requiresRef: true
  },
  {
    path: "/wpq/Overlay/Overlaytrans",
    component: WPQGrooveTransaction,
    access: "/WPQTransaction/Overlay",
    props: { type: TYPES.OVERLAY }
  },
  {
    path: "/WPQTransaction/TubetoTubesheet",
    component: WPQGroove_Overlay,
    access: "/WPQTransaction/TubetoTubesheet",
    props: { type: TYPES.TUBESHEET },
    requiresRef: true
  },
  {
    path: "/wpq/TubetoTubesheet/TubetoTubesheettrans",
    component: WPQTubeSheetTransaction,
    access: "/WPQTransaction/TubetoTubesheet",
    props: { type: TYPES.TUBESHEET }
  },

  // Master Routes
  {
    path: "/weldingmaster/Ano",
    component: Ano,
    access: "/weldingmaster/Ano",
    requiresRef: true
  },
  {
    path: "/weldingmaster/Fno",
    component: Fno,
    access: "/weldingmaster/Fno",
    requiresRef: true
  },
  {
    path: "/weldingmaster/WelderMaster",
    component: Welder,
    access: "/weldingmaster/WelderMaster",
    requiresRef: true
  },
  {
    path: "/weldingmaster/pcategory",
    component: PCategory,
    access: "/weldingmaster/pcategory",
    requiresRef: true
  },
  {
    path: "/weldingmaster/Project",
    component: ProjectMaster,
    access: "/weldingmaster/Project",
    requiresRef: true
  },
  {
    path: "/weldingmaster/SFA",
    component: SFA,
    access: "/weldingmaster/SFA",
    requiresRef: true
  },
  {
    path: "/weldingmaster/inspectionagency",
    component: InspectionAgencyMaster,
    access: "/weldingmaster/inspectionagency",
    requiresRef: true
  },
  {
    path: "/weldingmaster/dropdownvaluemaster",
    component: DropdownValueMaster,
    access: "/weldingmaster/dropdownvaluemaster",
    requiresRef: true
  },
  {
    path: "/weldingmaster/Training",
    component: TrainingMaster,
    access: "/weldingmaster/Training",
    requiresRef: true
  },
  {
    path: "/weldingmaster/TrainingRequisition",
    component: TrainingRequisition,
    access: "/weldingmaster/TrainingRequisition",
    requiresRef: true
  },

  // Maintenance Routes
  {
    path: "/maintenance/user",
    component: UserMaster,
    access: "/maintenance/user",
    requiresRef: true
  },
  {
    path: "/maintenance/role",
    component: RoleMaster,
    access: "/maintenance/role",
    requiresRef: true
  },

  // Additional Master Routes
  {
    path: "/weldingmaster/WPS",
    component: WeldingProcess,
    access: "/weldingmaster/WPS",
    requiresRef: true
  },
  {
    path: "/weldingmaster/Item",
    component: Item,
    access: "/weldingmaster/Item",
    requiresRef: true
  },
  {
    path: "/weldingmaster/TrainingRecord",
    component: TrainingRecord,
    access: "/weldingmaster/TrainingRecord",
    requiresRef: true
  },
  

  // WCS Routes
  {
    path: "/WCSDashboard",
    component: WCSDashboard,
    access: "/WCSDashboard",
    requiresRef: true
  },
  {
    path: "/wcsdetail",
    component: WCSDetail,
    access: "/WCSDashboard",
    requiresRef: true
  },

  // Deviation Routes (no access control)
  {
    path: "/raiseDeviation",
    component: RaiseDeviationCapa,
    requiresAuth: false,
    requiresRef: true
  },
  {
    path: "/raiseDeviation/deviationreport",
    component: DeviationReport,
    requiresAuth: false,
    requiresRef: true
  },

  // Other Transaction Routes
  {
    path: "/WITransaction",
    component: WIGridPage,
    access: "/WITransaction",
    requiresRef: true
  },
  {
    path: "/ListofWelders",
    component: List_Of_Welders,
    access: "/ListofWelders",
    requiresRef: true
  },
  {
    path: "/PRODTransaction",
    component: ProdLandPage,
    access: "/PRODTransaction",
    requiresRef: true
  },
  {
    path: "/PRODReport",
    component: ProdReport,
    access: "/PRODReport",
    requiresRef: true
  },
  {
    path: "/WelderRecordSheet",
    component: Welder_Record_sheet,
    access: "/WelderRecordSheet",
    requiresRef: true
  },
  {
    path: "/WelderContinuityRecord",
    component: WelderContinuityRecord,
    access: "/WelderContinuityRecord",
    requiresRef: true
  },
  {
    path: "/WQRTransaction",
    component: QualificationRequisition,
    access: "/WQRTransaction",
    requiresRef: true
  },

  // WPQ Linking Routes
  {
    path: "/Wpqlinking",
    component: WpqLinking,
    access: "/Wpqlinking",
    requiresRef: true
  },
  {
    path: "/Wpqlinking/AddEdit",
    component: WpqLinkingAddEdit,
    access: "/Wpqlinking",
    props: { type: TYPES.GROOVE },
    requiresRef: true
  },
  {
    path: "/WpqNpcilLinking",
    component: WpqNpcilLinking,
    access: "/WpqNpcilLinking",
    requiresRef: true
  },
  {
    path: "/WpqNpcilLinking/AddEdit",
    component: WpqNpcilLinkingAddEdit,
    access: "/WpqNpcilLinking",
    props: { type: TYPES.GROOVE },
    requiresRef: true
  },

  // Chart Routes
  {
    path: "/WQChart",
    component: WQChartReport,
    access: "/WQChart",
    requiresRef: true
  },

  // PQR Routes
  {
    path: "/PQRTransaction/Groove",
    component: PQRGroove_Overlay,
    access: "/PQRTransaction/Groove",
    props: { type: TYPES.GROOVE },
    requiresRef: true
  },
  {
    path: "/PQRTransaction/Overlay",
    component: PQRGroove_Overlay,
    access: "/PQRTransaction/Overlay",
    props: { type: TYPES.OVERLAY },
    requiresRef: true
  },
  {
    path: "/PQRTransaction/TubetoTubesheet",
    component: PQRGroove_Overlay,
    access: "/PQRTransaction/TubetoTubesheet",
    props: { type: TYPES.TUBESHEET },
    requiresRef: true
  },
  {
    path: "/pqr/Groove/Groovetrans",
    component: PQRGrooveTransaction,
    access: "/PQRTransaction/Groove",
    props: { type: TYPES.GROOVE }
  },
  {
    path: "/pqr/Overlay/Overlaytrans",
    component: PQRGrooveTransaction,
    access: "/PQRTransaction/Overlay",
    props: { type: TYPES.OVERLAY }
  },
  {
    path: "/pqr/TubetoTubesheet/TubetoTubesheettrans",
    component: PQRTubeSheetTransaction,
    access: "/PQRTransaction/TubetoTubesheet",
    props: { type: TYPES.TUBESHEET }
  },

  // Welding Repair Routes
  {
    path: "/weldingRepair/WeldingRepairAnalysis",
    component: WeldingRepairAnalysis,
    access: "/weldingRepair/WeldingRepairAnalysis",
    requiresRef: true
  },
  {
    path: "/weldingRepair/WeldingRepairAnalysisEntry",
    component: WeldingRepairAnalysisEntry,
    access: "/weldingRepair/WeldingRepairAnalysis"
  },
  {
    path: "/weldingRepair/WeldingRepairAnalysisViewAll",
    component: WeldingRepairAnalysisViewAll,
    access: "/weldingRepair/WeldingRepairAnalysis"
  }
];